/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import CreateView from '../../view/pages/transaction/CreateView'
import TransactionHeadStore from '../../store/transaction/TransactionHeadStore'
import TransactionDetailsStore from '../../store/transaction/TransactionDetailsStore'
import CreateViewStore from '../../store/transaction/CreateViewStore'
import ReservationStore from '../../store/transaction/ReservationStore'
import TransactionAction from '../../action/transaction'
import AccommodationTaxStore from '../../store/transaction/AccommodationTaxStore'
import ReservationPayStore from '../../store/transaction/ReservationPayStore'

class CreateContainer extends Component {
  static getStores() {
    return [TransactionHeadStore, TransactionDetailsStore, CreateViewStore, ReservationStore, AccommodationTaxStore, ReservationPayStore]
  }

  static calculateState(prevState, props) {
    return {
      view: CreateViewStore.getState(),
      reservation: ReservationStore.getState(),
      pay: ReservationPayStore.getState(),
      head: TransactionHeadStore.getState(),
      details: TransactionDetailsStore.getState(),
      accommodation_tax: AccommodationTaxStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const id = this.state.match.params.id
    if (id) {
      TransactionAction.fetchReservation(id)
    }
  }

  render() {
    return CreateView(this.state)
  }
}

export default withRouter(Container.create(CreateContainer, { withProps: true }))
